import { ApiCaller } from 'common/helpers/apiCaller';
import convertToQueryString from 'common/helpers/convertToQueryString';

import Axios from 'axios';
import Cookies from 'js-cookie';
import { Crypto } from 'common/helpers/crypto';

// ------ Menu Management ------ //
export const cafeteriaMenuManagementService = (data: object) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria?${convertToQueryString(data)}`
  });
};

// ------ Create Menu Management ------ //
export const cafeteriaCreateMenuManagementService = (data: object) => {
  return ApiCaller({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// ------ Create Menu Management ------ //
export const cafeteriaEditMenuManagementService = (data: object) => {
  return ApiCaller({
    method: 'PUT',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria`,
    data
  });
};

// ------ Chart ------ //
export const cafeteriaChartService = (data: { items: string; date: string }) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/chart?${data.items}&date=${data.date}`
  });
};

// ------ Status ------ //
export const cafeteriaStatusService = (data: object) => {
  return ApiCaller({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria-status`,
    data
  });
};

// ------ Update Image ------ //
export const cafeteriaUploadService = (data: object) => {
  return ApiCaller({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/upload`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// ------ Menu customization create ------ //
export const MenuCustomizationCreateService = (data: object) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/menu-item/option`,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ get menu customization ------ //
export const MenuCustomizationService = (data: object) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/menu-item/option?${convertToQueryString(data)}`
  });
};

// ------ get one item of menu customization ------ //
export const MenuCustomizationItemService = (id?: string | number) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/menu-item/option/${id}`
  });
};

// ------ Menu customization update ------ //
export const MenuCustomizationUpdateService = (data: object, id?: string | number) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/menu-item/option/${id}`,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ get one item of menu management ------ //
export const MenuManagementDetailService = (id?: string | number) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/${id}/details`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ Menu management update ------ //
export const MenuManagementUpdateService = (data: object) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'PUT',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria`,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ get REJECT REASONS LIST ------ //
export const RejectReasonsListService = (data: object) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order/cancel-reason?${convertToQueryString(data)}`
  });
};

// ------ REJECT REASONS create ------ //
export const RejectReasonCreateService = (data: object) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order/cancel-reason`,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ get one item reject reasons list ------ //
export const RejectReasonGetOneService = (id?: string | number) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order/cancel-reason/${id}`
  });
};

// ------ reject reason update ------ //
export const RejectReasonUpdateService = (data: object) => {
  const token = Cookies.get('token') ? Crypto.decrypt(Cookies.get('token')) : '';

  return Axios({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order/cancel-reason`,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Accept-Language': 'en, ar'
    }
  })
    .then((response) => response)
    .catch((error) => {
      console.error('Error making request:', error);
      throw error;
    });
};

// ------ get orders LIST ------ //
export const OrdersListService = (data: object) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order?${convertToQueryString(data)}`
  });
};

// ------ get one item of orders list ------ //
export const OrdersListGetOneService = (id?: string | number) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/cafeteria/order/${id}`
  });
};
